import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Upload additional "other" documents for Planning L1 on pending_rejection invoices.
 * Same file rules as vendor new invoice (PDF, Excel, CSV, MSG, KMZ).
 * @param {string} invoiceNumber
 * @param {File[]} files
 */
export const uploadApprovalPersonMissingDocuments = async (invoiceNumber, files) => {
  try {
    const formData = new FormData();
    (files || []).forEach((f) => formData.append('otherDocuments', f));
    const encoded = encodeURIComponent(invoiceNumber);
    const response = await apiClient.post(
      `/approvalPersonSystemInvoiceManagement/invoice/${encoded}/missing-documents`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data?.response ?? response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
